import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';

const uuidSchema = z.string().uuid();

export const Route = createFileRoute('/_private/_dashboard/beneficiaries/$id')({
  beforeLoad: ({ params }) => {
    const { id } = params;

    const result = uuidSchema.safeParse(id);

    if (!result.success) {
      throw notFound();
    }
  },
});
